import type { CredentialFieldDefaults } from '../../credential-defaults';

export function resolveCardPointeCredentialDefaults(): CredentialFieldDefaults {
    return {};
}
